import axios from "axios";
import "./axiosClient";
import { URL_PREFIX } from './apiBuilder';

const getTransactionId = () =>
  axios.get(`${URL_PREFIX}/sales/initTransaction`);

const updateCart = (transactionId, item) => axios.post(`${URL_PREFIX}/sales/${transactionId}/updateCart`, item);

const saveNormalSale = (transactionId, sale) =>
  axios.post(
    `${URL_PREFIX}/sales/${transactionId}/checkoutCounterSale`,
    sale
  );

const saveCreditSale = (transactionId, sale) =>
  axios.post(
    `${URL_PREFIX}/sales/${transactionId}/checkoutCreditSale`,
    sale
  );

const getTodaysSales = () =>
  axios.get(`${URL_PREFIX}/reports/todays-sales`);

const getSalesHistory = (startDate, endDate) =>
  axios.get(`${URL_PREFIX}/reports/todays-sales`, {
    params: { startDate, endDate }
  });

// eslint-disable-next-line
export default {
  getTransactionId,
  updateCart,
  saveNormalSale,
  saveCreditSale,
  getTodaysSales,
  getSalesHistory
};



